module.exports = __webpack_public_path__ + "static/media/ic_zoom.dbf54613.svg";